import React, { useEffect, useState } from 'react';

import { ActivityIndicator, Button, Checkbox, Toast, Modal, InputItem } from 'antd-mobile';
import * as crypto from 'crypto-js';
import { ApiCore } from '../../api';
import { createFromIconfontCN } from '@ant-design/icons';
import accountIcon from '../../static/icon/account.svg';
import passwordIcon from '../../static/icon/password.svg';
import { Encrypt, Decrypt } from "../../utils/crypto";
import utils from '../../utils/utils';
import {LOGIN_PAGE} from "../../config/config";
import ModalContent from './modal/modal';
import styles from './login.module.scss';
import methods from '../../utils/methods';
import { isTenant067 } from '../../utils/tenant-assoc';

const api = new ApiCore();

//设置阿里图库地址
const IconFont = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_2323742_xvjwsudf76n.js',
});

const colorRed = { color: 'red' }
const colorBlack = { color: '#000' }
const colorGreen = { color: 'green' }
let clears: any = null;

const checkPhone = (value: string)=> {
    return /^1[3-9]\d{9}$/.test(value)
}

function Login(props: any) {
    //设置加载状态
    const [loading, setLoading] = useState(false);
    //设置账户
    const [account, setAccount] = useState('');
    //设置密码
    const [password, setPassword] = useState('');
    //验证码
    const [captcha, setCaptcha] = useState('');
    const [seconds, setSeconds] = useState(0)
    //是否记住密码
    const [isrememberPwd, setIsrememberPwd] = useState<boolean>(false);

    //是否阅读知情同意书
    const [isRead, setIsRead] = useState<boolean>(false);

    //知情同意书modal
    const [agreementModal, setAgreementModal] = useState<boolean>(false);
    const [agreeType, setAgreeType] = useState<any>('agreement');

    const [vertifyCodeModal, setVertifyCodeModal] = useState<boolean>(false);
    const [codeTxt, setcodeTxt] = useState<any>('获取验证码');
    //验证码倒计时
    const [countDownSecond, setCountDownSecond] = useState<any>(60);
    //设置验证码文本
    const [showCode, setShowCode] = useState<boolean>(true);
    //是否发送验证码
    const [isSendCode, setIsSendCode] = useState<any>(false);
    const [checkedState, setCheckedState] = useState<any>(false);
    //验证码
    const [codes, setCodes] = useState<any>('');
    //设置验证码颜色
    const [isRed, setColor] = useState<any>(colorBlack);
    //数据返回结果
    const [dataResult, setDataResult] = useState<any>(null);
    //人脸签约弹窗
    const [faceSignModal, setFaceSignModal] = useState<boolean>(false);
    //弹窗内容
    const [faceContent, setFaceContent] = useState<string>('');
    //二维码地址
    const [signUrl, setSignUrl] = useState<string>('');

    useEffect(() => {
        //设置网页title
        document.title = '登录';

        let localStorage_accountInf = localStorage.getItem('accountInf');

        if (localStorage_accountInf) {
            let accountInf = JSON.parse(localStorage_accountInf);
            let account = accountInf.account;
            if (accountInf.password) {
                let passWord = crypto.AES.decrypt(accountInf.password, "accountInf").toString(crypto.enc.Utf8);
                setPassword(passWord);
                setIsrememberPwd(true);
            }
            else {
                setPassword('');
                setIsrememberPwd(false);
            }
            setAccount(account);
        }


        let checkAgreement = localStorage.getItem("checkAgreement")
        if (checkAgreement) {
            setIsRead(true)
        }
        return () => {
            //  销毁
            clearTimeout(clears);
        }
    }, [])

    //当账户发生改变
    const accountChange = (e: any) => {
        setAccount(e.target.value);
    }
    //当密码发生改变
    const passwordChange = (e: any) => {
        setPassword(e.target.value);
    }

    //选择了记住密码
    const rememberPwd = () => {
        let value = !isrememberPwd
        setIsrememberPwd(value)
    }

    //选择了阅读
    const handleRead = () => {
        if (!isRead) {
            setAgreementModal(true)
            setIsRead(false)
        }
        setIsRead(!isRead)
    }

    //选择协议
    const handleGreement = (type: any) => {
        setAgreementModal(true)
        setAgreeType(type)
    }

    //modal 确定
    const handleSure = (type: any) => {
        if (type === 'agree') {
            setIsRead(true)
            setAgreementModal(false)
        } else {
            setIsRead(false)
            setAgreementModal(false)
        }
    }
    
    
    //点击登录按钮
    const loginBtn = async () => {
        if (!isRead) {
            Toast.info('请先阅读并同意知情同意书', 1.5)
            return false;
        }

        if (!account) {
            Toast.fail('请先输入账户！', 1);
            return
        }

        if (!password) {
            Toast.fail('请先输入密码！', 1);
            return
        }

        // if (captcha.length !== 6) {
        //     Toast.fail('请先输入验证码！', 1);
        //     return
        // }

        // 校验短信
        // if (checkPhone(account)) {
        //     const params = {
        //         phone: account ? methods.trim(account, 'g') : '',
        //         phoneCode: captcha
        //     }
        //     const res = await api.ToResetPhoneValidate(params)
        //     if (res.code != '0') {
        //         Toast.fail(res.message || '验证失败', 0.8)
        //         return
        //     }
        // }

        const { tenantCode } = utils.getUrlParams()

        let params: any = {
            userCode: account,
            passWord: Encrypt(password)
        }

        if (tenantCode) {
            params.tenantCode = tenantCode
        }

        setLoading(true);
        const {code, message, data } = await api.login(params)
        setLoading(false);

        if (code == '0') {
            setDataResult(data)
            // const regExp = new RegExp(/^1[3-9]\d{9}$/);
            // // 君实账号做手机号验证码验证
            // if(res.data.isJs == 1 && regExp.test(account)){
            //     setVertifyCodeModal(true)
            //     setLoading(false);
            //     return
            // }
            
            // 先临时写入token，保证faceSign请求能带上正确的x-auth-token
            const user = {
                userName: data.userName,
                tenantName: data.tenantName,
                tenantCode: data.tenantCode,
                token: data.token,
                roleCode: data.roleCode,
                roleCodes: data.roleCodes,
                userCode: account,
                tenantConfig: data.tenantConfig,
                isJs: data.isJs,
            }
            sessionStorage.setItem('token', JSON.stringify(user));
            localStorage.setItem('token', JSON.stringify(user));
            
            checkFaceSign(account, data)
        }
        else if (code == '50050202') {
            Toast.fail('该用户不存在！', 1);
        }
        else if (code == '50050203') {
            Toast.fail('用户密码错误！', 1);
        }
        else {
            if (message) {
                Toast.fail(message, 1);
            }
            else {
                Toast.fail('账号或密码输入次数已超限3次,请10分钟后再试!', 1);
            }
        }
    }
    //检查人脸签约
    const checkFaceSign = async (userCode: string, loginData?: any) => {
        const { code, data } = await api.faceSign({ userCode })
        if (code == '0' && data && data.showPopup === 1) {
            setFaceSignModal(true)
            setFaceContent(data.faceContent || '')
            setSignUrl(data.signUrl || '')
        } else {
            saveLoginInfo(loginData || dataResult)
        }
    }

    //重新检查签约状态
    const handleRefreshFaceSign = async () => {
        const userCode = dataResult?.userCode || account;
        if (userCode) {
            checkFaceSign(userCode)
        }
    }

    //保存登录信息
    const saveLoginInfo = (data:any)=>{
        let user = {
            userName: data.userName,
            tenantName: data.tenantName,
            tenantCode: data.tenantCode,
            token: data.token,
            roleCode: data.roleCode,
            roleCodes: data.roleCodes,
            userCode: account,
            tenantConfig: data.tenantConfig,
            isJs: data.isJs,
        }
         sessionStorage.setItem('token', JSON.stringify(user));
         sessionStorage.setItem('tenant-configuration', JSON.stringify(user.tenantConfig || {}))
         sessionStorage.setItem('targetName', user.tenantConfig?.label == 1?'患者':'受试者');
         localStorage.setItem('token', JSON.stringify(user));
         localStorage.setItem('tenantCode', user.tenantCode)

         //账户信息
         let accountInf;

         if (isrememberPwd) {
             //加密的密码
             let cipherPassword = crypto.AES.encrypt(password, "accountInf").toString();
             //账户信息
             accountInf = {
                 account: account,
                 password: cipherPassword
             }
         } else {
             //账户信息
             accountInf = {
                 account: account,
                 password: ''
             }
         }

         //清除本地存储
         // localStorage.clear();
         //保存账户密码信息
         localStorage.setItem('accountInf', JSON.stringify(accountInf));
         localStorage.setItem('checkAgreement', 'true')
         Toast.success(`欢迎回来！${data.userName}`, 1);
         if (data.tenantConfig && data.tenantConfig.route) {
             props.history.replace(data.tenantConfig.route);
         } else {
             props.history.replace('/home');
         }
    }
    const handleTest = () => {
        console.log("开始调用！")
        window['wx'].miniProgram.navigateTo({
            // url: 'https://edc-saas-test.huimeimt.com/wxaurl/HTea1hSb5vl',
            url: '/pages/loading/loading',
            success: function (e:any) {
                console.log("success:"+JSON.stringify(e));
            },
            fail: function(err:any) {
                console.log("fail:"+JSON.stringify(err));
            },
            complete: function(e:any) {
                console.log("complete:"+JSON.stringify(e));
            }
        });
    }

    // 重置密码
    const toFindPwd = () => {
        sessionStorage.setItem('ResetPasswordFromPath', '/login');
        props.history.push('/doctor/resetPassword');
    }

      //60s验证码倒计时
      const handleCountDown = (seconds = 60) => {
        let second = seconds;
        const countDown = () => {
            if (second > 0) {
                second--;
                setCountDownSecond(second);
            }
            if (second === 0) {
                second = 60;
                setCountDownSecond(second);
                setShowCode(true);
                setIsSendCode(false);
                setcodeTxt('重新获取验证码');
                return;
            }
            clears = setTimeout(countDown, 1000);
        };
        clears = setTimeout(countDown, 1000);
    };

      //获取验证码
    const onCode = (value: any) => {
        setCodes(value);
        setColor(colorBlack);
    }

    // 发送验证码
    const sendCode = (value: any) => {

        const params = {
            phone: account
        }
        api.SendCode(params).then(res => {
            if (res.code == '0') {
                setIsSendCode(true);
                setShowCode(false);
                handleCountDown(60);
            }
            else {
                Toast.fail(res.message, 0.8)
            }
        })

    }

    // 处理验证码事件
    const handleCodeModal = (val: string)=>{
        if(val === 'sure'){
            if (!codes) {
                Toast.fail('请输入验证码！', 0.8)
                return
            }
            let params = {
                phone: account ? methods.trim(account, 'g') : '',
                phoneCode: codes
            }
         
            api.ToResetPhoneValidate(params).then(res => {
                if (res.code == '0') {
                    setVertifyCodeModal(false)
                    saveLoginInfo(dataResult)
                } else {
                    Toast.fail(res.message || '验证失败', 0.8)
                }
            });
        }else{
            setCodes(null)
            setVertifyCodeModal(false)
        }
        
    }

    const handleSend = async()=> {
        if (!checkPhone(account)) {
            Toast.fail('请输入手机号码！')
            return
        }
        await api.SendCode({ phone: account })

        let s = 60

        let timer = setInterval(()=> {
            if (s > 0) {
                s--
                setSeconds(s)
            } else {
                clearInterval(timer)
            }
        }, 1000)
    }

    return (
        <div className={LOGIN_PAGE === 'default' ? styles.login_content : styles['login_'+LOGIN_PAGE]}>
            <div className={styles.login_box}>
                <div className={styles.header}>
                    <div className={styles.logo_content}>
                        {/* <div className={styles.logo}></div> */}
                    </div>
                    <div className={styles.title_content}>
                        <div className={styles.title}>
                            科研数据小助手
                        </div>
                        <div className={styles.info}>
                            Research Data Tool
                        </div>
                    </div>

                </div>
                <div className={styles.form_content}>
                    <div className={styles.inputWrap}>
                        {/* <IconFont type="iconAccount"></IconFont> */}
                        <img src={accountIcon} alt="account" />
                        <div className={styles.inputContent}>
                            <input
                                type={'text'}
                                placeholder={'请输入您的账户'}
                                maxLength={100}
                                value={account}
                                onChange={accountChange}
                            />
                        </div>
                    </div>
                    <div className={styles.inputWrap}>
                        {/* <IconFont type="iconLock"></IconFont> */}
                        <img src={passwordIcon} alt="password" />
                        <div className={styles.inputContent}>
                            <input
                                type={'password'}
                                placeholder={'请输入您的密码'}
                                maxLength={100}
                                value={password}
                                onChange={passwordChange}
                            />
                        </div>
                    </div>
                    {/*
                    <div className={styles.inputWrap}>
                        <img src={passwordIcon} alt="password" />
                        <div className={`${styles.inputContent} ${styles.inputCaptcha}`}>
                            <input
                                type='text'
                                placeholder={'请输入验证码'}
                                maxLength={100}
                                value={captcha}
                                onChange={({target})=> {
                                    setCaptcha(target.value)
                                }}
                            />
                            <button disabled={seconds > 0} onClick={handleSend} type="button">{seconds === 0 ? '发送验证码' : `${seconds}秒后可重发`}</button>
                        </div>
                    </div>
                    */}
                    <div className={styles.checkboxs}>
                        <div className={styles.agreement}>
                            <Checkbox checked={isRead} onChange={handleRead}></Checkbox>
                            {/* &nbsp;<span onClick={() => setAgreementModal(true)}>《知情同意书》</span> */}
                            &nbsp;<span onClick={() => handleGreement('agreement')}>《用户协议》、</span>
                            <span onClick={() => handleGreement('policy')}>《隐私政策》</span>
                        </div>
                        <div className={styles.rememberPwd}>
                            <Checkbox checked={isrememberPwd} onChange={rememberPwd}></Checkbox>&nbsp;记住密码
                        </div>
                    </div>
                    <div className={styles.login_btn}>
                        <Button className={styles.btn} type="primary" disabled={loading} onClick={loginBtn} loading={loading}>登录</Button>
                    </div>
                    <div className={styles.find_pwd}>
                        <span onClick={ () => { toFindPwd() }}>找回密码</span>
                    </div>
                </div>
                <div className={styles.bg_content}>

                </div>
            </div>

            <ActivityIndicator animating={loading} size={"small"} text={'正在加载数据'} toast />

            <Modal
                visible={agreementModal}
                transparent
                maskClosable={false}
                title=""
                style={{ width: '90%' }}
                footer={[
                    { text: '不同意', onPress: () => handleSure('disagree') },
                    { text: '同意', onPress: () => handleSure('agree') }
                ]}
            >
                <ModalContent type={agreeType} />
            </Modal>


            <Modal
                visible={vertifyCodeModal}
                transparent
                maskClosable={false}
                title="手机号验证码校验"
                style={{ width: '90%' }}
                footer={[
                    { text: '取消', onPress: () => handleCodeModal('cancel') },
                    { text: '确定', onPress: () => handleCodeModal('sure') }
                ]}
            >   
                <div className={styles.form_content}>
                        <div className={`${styles.InputItemContent} ${styles.smsWrap}`}>
                            <InputItem
                                value={codes}
                                placeholder="请输入短信验证码"
                                type='number'
                                maxLength={6}
                                extra={
                                    showCode ?
                                        <Button onClick={sendCode} type="primary">{codeTxt}</Button> :
                                        <Button >{`${countDownSecond}s`}</Button>
                                }
                                onChange={onCode}
                                style={isRed}
                            ></InputItem>
                            </div>
                </div>
            </Modal>

            <Modal
                visible={faceSignModal}
                transparent={false}
                maskClosable={false}
                closable={false}
                title=""
                style={{ width: '90%' }}
                footer={[]}
            >
                <div style={{ textAlign: 'center', padding: '20px 10px' }}>
                    <div 
                        style={{ maxWidth: '100%', wordBreak: 'break-all' }}
                        dangerouslySetInnerHTML={{ __html: faceContent }}
                    />
                    {signUrl && (
                        <div style={{ marginTop: 20 }}>
                            <img 
                                src={signUrl} 
                                alt="签约二维码" 
                                style={{ width: 180, height: 180 }}
                            />
                            <div style={{ marginTop: 10, color: '#666', fontSize: 14 }}>
                                请使用微信扫描二维码完成签约
                            </div>
                        </div>
                    )}
                    <div style={{ marginTop: 30, textAlign: 'center' }}>
                        <Button type="primary" onClick={handleRefreshFaceSign}>
                            我已完成签约，刷新页面
                        </Button>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default Login;
